import React from 'react';
import { connect } from 'react-redux';
import {
  Dialog,
  FlatButton,
  Avatar,
  LinearProgress,
  RaisedButton,
} from 'material-ui';
import BackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import injectSheet from 'react-jss';
import { push as routerPush } from 'react-router-redux';
import ForContractRequest from './for-contract-request';
import RequestSigDialog from './request-sigs-dialog';
import LoadingOverlay from '../../tc-ui/loading-overlay';
import R from 'ramda';

const styles = {
  dialogContent: {
    width: '100% !important',
    maxWidth: 'none !important',
    transform: 'none !important',
  },
  dialogBody: {
    height: 'calc(100vh - 64px)',
    padding: '0 !important',
    maxHeight: 'none !important',
    // height: '100%',
  },
  dialogRoot: {
    paddingTop: '0 !important',
  },
};

const RateDocIframe = ({
  open,
  url,
  buyerLogo,
  buyerName,
  isInSigning,
  forImport,
  forCCImport,
  // backToLabel,
  // showEditor,
  classes: css,
  onClose,
  acceptingDummyTemplate,
  loading,
  crIds = [],
  rateDocId,
  selectTemplateForImport,
  // trackEvent,
}) => {
  if (!open) return null;
  const inSigning = isInSigning || window.location.href.indexOf('assets-landing') > -1;
  const handleClose = () => onClose(crIds[0]);
  const handleSelectImportTemplate = () => selectTemplateForImport(rateDocId, forCCImport);
  const handleFrameLoad = () => {
    // trackEvent({ name: `[Wall] Opened ${slug}`, ga: {
    //   eventCategory: 'account',
    //   eventAction: 'wallOpen',
    //   eventValue: slug,
    // }});
  };
  const title = forImport ? (
    <div style={{ height: '64px', lineHeight: 'none', padding: '0 16px', color: '#fff', backgroundColor: '#00bcd4', fontSize: '14px' }} className="flex-tc-sb">
      <span>
        {forCCImport ? 'PRIVACY NOTE: Rates and sensitive data has been hidden for privacy purposes.  You can add rates after you complete this import.' : ''}
      </span>
      <div>
        <FlatButton
          labelStyle={{ fontWeight: 'bold', color: '#fff' }}
          label="Close Preview"
          icon={<CloseIcon color="#fff"/>}
          onClick={handleClose}
        />&nbsp;&nbsp;&nbsp;
        <RaisedButton
          labelStyle={{ fontWeight: 'bold', color: '#00bcd4' }}
          label="Select this rate sheet"
          icon={<CheckIcon color="#00bcd4"/>}
          onClick={handleSelectImportTemplate}
        />
      </div>
    </div>
  ) : (
    <div style={{ height: '64px', backgroundColor: '#fff', lineHeight: 'none', padding: '0 8px', color: '#000' }}>
      <div className="flex-tc-sb" style={{ height: '62px' }}>
        <FlatButton
          labelStyle={{ fontWeight: 'bold' }}
          label={inSigning ? 'Go Back & Sign' : 'Back'}
          icon={<BackIcon/>}
          onClick={handleClose}
        />
        {
          (() => {
            if (inSigning) {
              return (
                <div className="flex-center">
                  {buyerLogo ? (
                    <Avatar src={buyerLogo}/>
                  ) : (
                    <Avatar>{R.first(buyerName || '')}</Avatar>
                  )}&nbsp;&nbsp;
                  {buyerName}
                </div>
              );
            }
            if (url.indexOf('forDiffing') > -1) return <span/>;
            return <ForContractRequest/>;
          })()
        }
      </div>
      {loading && <LinearProgress style={{ flexGrow: 1, height: '12px', borderRadius: '5px', width: '50%', margin: '16px auto' }} />}
    </div>
  );
  const iframeInIframe = window.location.href.indexOf(process.env.SECONDARY_SYSTEM_URL) > -1 && forCCImport;
  return (
    <div>
      <Dialog
        style={{
          zIndex: 2101,
          ...(iframeInIframe ? { left: '10%', width: '80%', top: '16px' } : {}),
        }}
        className={css.dialogRoot}
        open={open}
        onRequestClose={handleClose}
        title={title}
        contentClassName={css.dialogContent}
        bodyClassName={css.dialogBody}
      >
        <iframe src={url} style={forImport ? { border: 'none' } : {}} width="100%" height="100%" title="Rates Iframe" onLoad={handleFrameLoad}/>
      </Dialog>
      {
        !inSigning && (
          <RequestSigDialog/>
        )
      }
      <LoadingOverlay
        loading={acceptingDummyTemplate}
      />
    </div>
  );
};
/*
*onClick={handleCose} />
*/
/*
      <div style={{ backgroundColor: 'rgb(250, 250, 250)', position: 'fixed', top: 0, left: 0, height: '100%', width: '100%', zIndex: 1350 }}>
        <iframe src={ url } width='100%' height='100%' title="Upgrade Promo"/>
      </div>
*/
export default connect(
  ({ dummyAcct: { rateDocIframe } }) => rateDocIframe,
  {
    onClose: crId => ({ type: '{dummy-account} RateDocIframe_close', payload: { crId } }),
    trackEvent: payload => ({
      type: 'TRACK_EVENT',
      payload,
    }),
    push: routerPush,
    selectTemplateForImport: (docId, forCCImport) => ({ type: 'RateDocIframe_selectImportTemplate', payload: { docId, forCCImport } }),
  },
)(injectSheet(styles)(RateDocIframe));



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/rate-doc-iframe.jsx